// "Adicionado ao carrinho!" no meio da tela (verbatim).
export default function AnimacaoAdicionado({ addedAnim }) {
  if (!addedAnim) return null;
  return (<>
{/* Added to cart animation */}
{addedAnim && (
  <div key={addedAnim.key} className="fixed inset-0 z-[200] flex items-center justify-center pointer-events-none">
    <style>{`
      @keyframes cart-pop-in {
        0% { transform: scale(0.3); opacity: 0; }
        50% { transform: scale(1.05); opacity: 1; }
        70% { transform: scale(0.95); }
        100% { transform: scale(1); opacity: 1; }
      }
      @keyframes cart-fade-out {
        0% { opacity: 1; transform: scale(1); }
        100% { opacity: 0; transform: scale(0.8) translateY(-30px); }
      }
      .cart-anim-enter {
        animation: cart-pop-in 0.5s ease-out forwards, cart-fade-out 0.4s ease-in 1.3s forwards;
      }
    `}</style>
    <div className="cart-anim-enter bg-zinc-900/95 backdrop-blur-md border-2 border-green-500/50 rounded-3xl px-12 py-8 flex flex-col items-center gap-4 shadow-2xl shadow-green-500/20">
      <div className="w-20 h-20 rounded-full bg-green-500 flex items-center justify-center">
        <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
      </div>
      <p className="text-2xl font-black text-zinc-100 text-center max-w-xs">{addedAnim.name}</p>
      <p className="text-lg font-bold text-green-400">Adicionado ao carrinho!</p>
    </div>
  </div>
)}
  </>);
}
